
	import Modal from '@/components/Modal.vue';
	import ShoeSizePicker from '@/components/ShoeSizePicker.vue';
	import { Component, Vue } from 'vue-property-decorator';
	import { Packs, packs } from '@/store/ProductStore';
	import { Observer } from 'mobx-vue';
	import { toJS } from 'mobx';
	import { ShoeSizeUnit, ShoeType } from '@/store/ShoeMeasurements';
	import { PatientUIData } from '@/store/patientStore';

	@Observer
	@Component({
		components: { ShoeSizePicker, Modal }
	})
	export default class ShoeSizeModal extends Vue {
		public options = packs;
		private pickedCopy: Packs = packs[2];

		patientData?: PatientUIData;

		close() {
			this.cancel();
			this.$emit('close');
		}

		mounted() {
			this.pickedCopy = this.$state.product.pack;
			this.patientData = toJS(this.$state._patient.patientUIData);
		}

		cancel() {
			if (this.patientData) {
				this.$state._patient.patientUIData = this.patientData;
			}
		}

		save() {
			this.$state.product.pack = this.pickedCopy;
			this.$state._patient.updateMedicalProfile({ update: true });
			this.$state.leroy.onPrescriptionChanged();
			this.$state.prescription.delayedSavePrescription();
			this.$emit('close');
		}

		private isDisabled(type: string) {
			switch (type) {
				case 'Pair':
					return !this.$state.biometric.bothScansExist;
				case 'Left Only':
					return !(this.$state.biometric.bothScansExist || this.$state.biometric.leftScanExists);
				case 'Right Only':
					return !(this.$state.biometric.bothScansExist || this.$state.biometric.rightScanExists);
			}
		}
	}
